/**
 * 自定义组件最简结构
 */
import React from "react";
import PropTypes from "prop-types";
import { component_tool } from "@/tool";
import { Link } from "dva/router";
import cs from 'classnames'
import "./index.less";

// const { WizComponent } = component_tool;
const {
  WizDivider,
  WizTabs,
  WizAntdForm,
  WizButton,
  WizInput,
  WizSpin,
} = component_tool;
const { TabPane } = WizTabs;

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSubmit = e => {
    e.preventDefault();
    const { onSubmit } = this.props

    this.props.form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values)
      }
    });
  };

  // phone = () => (
  //   <TabPane tab="手机登录" key="2">
  //   <WizAntdForm
  //     name="phone_login"
  //     className="normal-login"
  //     onSubmit={this.handleSubmit}
  //   >
  //     <WizAntdForm.Item className="form-item">
  //     {getFieldDecorator('phone', {
  //       rules: [
  //         { required: true, message: '请输入手机号' },
  //       ],
  //     })(<WizInput
  //         placeholder="请输入您的手机号"
  //         prefix={
  //           <img
  //             src={require("assets/images/login/icon/icon-phone.png")}
  //           />
  //         }
  //       />)}
  //     </WizAntdForm.Item>

  //     <WizAntdForm.Item className="form-item">
  //     {getFieldDecorator('phoneCode', {
  //       rules: [
  //         { required: true, message: '请输入短信验证码' },
  //       ],
  //     })(<WizInput
  //         placeholder="请输入短信验证码"
  //         style={{ width: 180 }}
  //       />)}
  //       <WizButton type="primary" block={true} className="btn-phone">
  //         获取验证码
  //       </WizButton>
  //     </WizAntdForm.Item>

  //     <WizAntdForm.Item>
  //       <WizButton
  //         type="primary"
  //         htmlType="submit"
  //         block={true}
  //         className="btn-submit"
  //         loading={!!submitLoading}
  //       >
  //         进入学习平台
  //       </WizButton>
  //     </WizAntdForm.Item>
  //   </WizAntdForm>
  // </TabPane>
  // )

  render() {
    const { imageBase64, submitLoading, captchaLoading, getCaptcha, onSubmit, className, form } = this.props;
    const { getFieldDecorator } = form;
    return (
      <div className={cs('login-form', className)}>
        <WizTabs
          className="login-tabs"
          // defaultActiveKey="1"
          animated={false}
        >
          <TabPane tab="账号登录" key="1">
            <WizSpin spinning={!!captchaLoading}>
              <WizAntdForm
                name="normal_login"
                className="normal-login"
                onSubmit={this.handleSubmit}
              >
                <WizAntdForm.Item className="form-item">
                {getFieldDecorator('username', {
                  rules: [
                    { required: true, message: '请输入账号' },
                  ],
                })(<WizInput
                    placeholder="请输入您的账号"
                    prefix={
                      <img
                        src={require("assets/images/login/icon/icon-user.png")}
                      />
                    }
                  />)}
                </WizAntdForm.Item>
                <WizAntdForm.Item className="form-item" >
                {getFieldDecorator('password', {
                  rules: [
                    { required: true, message: '请输入密码' },
                  ],
                })(<WizInput
                    type="password"
                    placeholder="请输入您的密码"
                    prefix={
                      <img
                        src={require("assets/images/login/icon/icon-password.png")}
                      />
                    }
                  />)}
                </WizAntdForm.Item>

                <WizAntdForm.Item className="form-item">
                {getFieldDecorator('captchaCode', {
                  rules: [
                    { required: true, message: '请输入验证码' },
                  ],
                })(<WizInput
                    type="captcha"
                    placeholder="请输入验证码"
                    onPressEnter={this.handleSubmit}
                    style={{ width: 189 }}
                    maxLength={4}
                  />)}
                  <img
                    src={imageBase64}
                    alt="验证码"
                    className="code-img"
                    onClick={getCaptcha}
                  />
                </WizAntdForm.Item>

                <WizButton
                  type="primary"
                  htmlType="submit"
                  block={true}
                  size="large"
                  className="btn-submit"
                  loading={!!submitLoading}
                >
                  进入学习平台
                </WizButton>
              </WizAntdForm>
            </WizSpin>
          </TabPane>
        </WizTabs>
        <div className="forgotPassword">
          
        </div>
      </div>
    );
  }
}

/**
 * 默认值
 */
LoginForm.defaultProps = {};

/**
 * props入参校验
 */
LoginForm.propTypes = {
  /**
   * 数据源data
   */
};

export default WizAntdForm.create({ name: 'normal_login' })(LoginForm)
